import o from"styled-components";import{COLORS as t}from"../../../../../constants/Theme.js";const r=o.div`
	flex-direction: row;
	align-items: start;
	display: flex;
`,i=o.div`
	display: flex;
	margin-left: 28px;
	width: 1px;
	height: 24px;
	background: ${t.stroke.primary};
`,e=o.div`
	display: flex;
	border-bottom-width: 1px;
	border-bottom-style: solid;
	border-bottom-color: ${t.stroke.primary};
	width: 24px;
`;export{r as Container,e as Horinzontal,i as Line};
